import { Box, Flex } from '@chakra-ui/layout';
import { Button, Input, useToast } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Typography } from 'packages/common-frontend/components/Typography';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { WizardComponent } from '~/core/routes/settings/implementations/create/ImplementationWizard';
import { useCreateSingleFacilityImplementationMutation } from '~/core/routes/settings/implementations/implementations.gql.generated';
import { errorToastConfig } from '~/packages/common-frontend/constants';

export const NameImplementation: WizardComponent = ({
  implementationName,
  setImplementationName,
  previousStep,
  selectedOrgs,
}) => {
  const toast = useToast();
  const { user } = useUserAuthOrThrow();
  const navigate = useNavigate();
  const [
    createSingleFacilityImplementation,
    { loading },
  ] = useCreateSingleFacilityImplementationMutation();

  const onNext = async () => {
    const parties = selectedOrgs
      .filter((org) => org.type !== undefined && org.type !== null)
      .map((org) => ({
        organizationId: org.id,
        partyType: org.type!,
      }));

    try {
      const response = await createSingleFacilityImplementation({
        variables: {
          ownerOrganizationId: user.organizationId,
          creditFacilityName: implementationName,
          creditFacilityParties: parties,
        },
      });

      navigate(
        `/settings/implementations/${response.data?.createSingleFacilityImplementation.id}`,
      );
    } catch (err) {
      toast({
        ...errorToastConfig,
        title: 'There was an error creating a new implementation',
      });
    }
  };

  return (
    <Box width="100%">
      <Box>
        <Typography variant="page-title">Name the Facility</Typography>
        <Typography variant="base-muted">
          This name will be used across the platform and can be modified at any
          time.
        </Typography>
      </Box>
      <Box borderWidth="thin" borderRadius="8px" padding="2rem" my="2rem">
        <Typography variant="section-subtitle">Facility Name</Typography>
        <Input
          value={implementationName}
          placeholder="Name"
          onChange={(event) => setImplementationName(event.target.value)}
          autoFocus
        />
      </Box>
      <Flex justify="space-between">
        <Button onClick={previousStep}>Back</Button>
        <Button
          variant="primary"
          colorScheme="v2-aurora"
          isDisabled={loading || implementationName.length === 0}
          onClick={onNext}
        >
          Create
        </Button>
      </Flex>
    </Box>
  );
};
